mounted
<template>
    <div class="empresas-container">
        <div class="d-flex justify-content-between align-items-center mb-4">
            <div class="d-flex align-items-center">
                <button class="btn-back" @click="$router.push('/')">
                    <i class="fas fa-arrow-left"></i>
                </button>
                <h1 class="page-title ml-3">Empresas</h1>
            </div>
            <b-button v-if="isSuperAdmin" class="btn-orange mb-3" @click="abrirModal">
                <i class="fas fa-plus-circle mr-2"></i>Nova Empresa
            </b-button>
        </div>

        <div class="box">
            <div class="mb-4">
                <div class="flexline">
                    <h2 class="filter-title">Filtrar</h2>
                    <b-form-select v-model="ordenacao" :options="ordenacaoOpcoes" @change="ordenarEmpresas"
                        class="listbox" />
                </div>
            </div>

            <b-spinner v-if="loading" />
            <div v-else>
                <div class="table-responsive-wrapper">
                    <b-table :items="items" :fields="fields" striped hover responsive class="modern-table">
                        <template #cell(acoes)="data">
                            <div class="action-buttons">
                                <b-button v-if="isSuperAdmin" class="btn-orange-action" @click="abrirModalEdicao(data.item.id)">
                                    <i class="fas fa-edit"></i>
                                    <span class="btn-text"> Editar</span>
                                </b-button>
                                <b-button class="btn-orange-action"
                                @click="irParaAnalises(data.item.id)">
                                    <i class="fas fa-chart-line"></i>
                                    <span class="btn-text"> Análises</span>
                                </b-button>
                                <b-button class="btn-orange-action"
                                @click="abrirEquipamentosModal(data.item.id)">
                                    <i class="fas fa-tools"></i>
                                    <span class="btn-text"> Equipamentos</span>
                                </b-button>
                                <b-button v-if="isSuperAdmin" class="btn-danger-action" @click="confirmarExclusao(data.item)">
                                    <i class="fas fa-trash"></i>
                                    <span class="btn-text"> Excluir</span>
                                </b-button>
                            </div>
                        </template>
                    </b-table>
                </div>
            </div>
            <p v-if="error" class="error">{{ error }}</p>
        </div>

        <!-- Modal de Nova empresa e Editar empresa -->
        <b-modal id="modal-vazio" ref="modalVazio" hide-footer hide-header size="xl" :modal-class="'modal-fullscreen'">
            <div>
                <h1>{{ isEdicao ? 'Editar Empresa' : 'Nova Empresa' }}</h1>
                <div class="box">
                    <b-spinner v-if="carregandoEdicao" />
                    <b-form v-else @submit.prevent="onSubmit">
                        <h3 class="section-title">Dados da Empresa</h3>
                        <b-row>
                            <b-col md="6">
                                <b-form-group label="Nome da Empresa">
                                    <b-form-input v-model="form.companyNome" type="text" required
                                        placeholder="Digite o nome da empresa"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="Email da Empresa">
                                    <b-form-input v-model="form.companyEmail" type="email" required
                                        placeholder="contato@empresa.com"
                                        pattern="[a-z0-9._%+\-]+@[a-z0-9.\-]+\.[a-z]{2,}$"></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="4">
                                <b-form-group label="Telefone">
                                    <b-form-input v-model="form.companyTelefone" type="text" required
                                        placeholder="(99) 99999-9999" @input="formatarTelefone"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col md="4">
                                <b-form-group label="Documento (CNPJ/CPF)">
                                    <b-form-input v-model="form.companyDocumento" type="text" required
                                        placeholder="CPF ou CNPJ" @input="formatarCompanyDocumento"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col md="4">
                                <b-form-group label="Razão Social">
                                    <b-form-input v-model="form.companyRazaoSocial" type="text" required
                                        placeholder="Digite a razão social"></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="6">
                                <b-form-group label="Estado">
                                    <b-form-select
                                        v-model="form.companyEstado"
                                        :options="estadoOptions"
                                        required
                                        @change="updateCitiesByState"
                                    />
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="Cidade">
                                    <b-form-select
                                        v-model="form.companyCidade"
                                        :options="cidadeOptions"
                                        :disabled="!form.companyEstado"
                                        required
                                    />
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <h3 class="section-title mt-4">Dados do Gerente</h3>

                        <b-row v-if="isEdicao">
                            <template>
                                <b-col md="6">
                                    <b-form-group label="Gerente">
                                        <b-form-select
                                            v-model="form.managerSelecionadoId"
                                            :options="opcoesGerentes"
                                            required
                                            @change="selecionarGerente"
                                        >
                                            <template #first>
                                                <b-form-select-option :value="null" disabled>
                                                    Selecione o gerente
                                                </b-form-select-option>
                                            </template>
                                        </b-form-select>
                                    </b-form-group>
                                </b-col>
                                <b-col md="6">
                                    <b-form-group label="Email do Gerente">
                                        <b-form-input v-model="form.managerEmail" type="email" readonly></b-form-input>
                                    </b-form-group>
                                </b-col>
                            </template>
                        </b-row>

                        <template v-else>
                            <b-row>
                                <b-col md="6">
                                    <b-form-group label="Nome do Gerente">
                                        <b-form-input v-model="form.managerNome" type="text" required
                                            placeholder="Digite o nome do gerente"></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col md="6">
                                    <b-form-group label="Email do Gerente">
                                        <b-form-input v-model="form.managerEmail" type="email" required
                                            placeholder="gerente@empresa.com"
                                            pattern="[a-z0-9._%+\-]+@[a-z0-9.\-]+\.[a-z]{2,}$"></b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="4">
                                    <b-form-group label="Senha">
                                        <b-form-input v-model="form.managerSenha" type="password" required
                                            placeholder="Digite a senha"></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col md="4">
                                    <b-form-group label="Confirmar Senha">
                                        <b-form-input v-model="form.managerConfirmarSenha" type="password" required
                                            placeholder="Confirme a senha" :state="senhasConferem"></b-form-input>
                                        <b-form-invalid-feedback :state="senhasConferem">
                                            As senhas não conferem
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </b-col>
                                <b-col md="4">
                                    <b-form-group label="Documento (CPF)">
                                        <b-form-input v-model="form.managerDocumento" type="text" required
                                            placeholder="CPF do gerente" @input="formatarManagerDocumento"></b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </template>

                        <b-button type="submit" class="btn-orange" :disabled="!formValido">
                            {{ isEdicao ? 'Salvar Alterações' : 'Salvar' }}
                        </b-button>
                        <b-button class="btn-cancel ml-2" @click="fecharModal">Cancelar</b-button>
                    </b-form>
                </div>
            </div>
        </b-modal>

        <equipamentos-modal ref="equipamentosModal" :equipamentos="equipamentos"
            :empresa="empresaSelecionada"></equipamentos-modal>
    </div>
</template>

<style>
.empresas-container {
  animation: fadeIn 0.3s ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.btn-back {
  background: linear-gradient(135deg, #FF8C42 0%, #FF7A29 100%);
  border: none;
  color: white;
  width: 45px;
  height: 45px;
  min-width: 45px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(255, 140, 66, 0.3);
  flex-shrink: 0;
}

.btn-back:hover {
  background: linear-gradient(135deg, #FF7A29 0%, #FF6810 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(255, 140, 66, 0.4);
}

.btn-back i {
  font-size: 1.2rem;
}

.page-title {
  font-size: 2rem;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 0;
}

.box {
    padding: 30px;
    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
    border-radius: 20px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;
}

.box:hover {
  box-shadow: 0 6px 30px rgba(0, 0, 0, 0.12);
}

.filter-title {
  font-size: 1.3rem;
  font-weight: 600;
  color: #495057;
}

.flexline {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 15px;
    flex-wrap: wrap;
}

.listbox {
  max-width: 250px;
  border: 2px solid #FF8C42;
  border-radius: 8px;
  padding: 8px 12px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.listbox:focus {
  border-color: #FF7A29;
  box-shadow: 0 0 0 0.2rem rgba(255, 140, 66, 0.25);
}

/* Header responsive */
.d-flex.justify-content-between.align-items-center.mb-4 {
  flex-wrap: wrap;
  gap: 12px;
}

/* Tablet */
@media (max-width: 991px) {
  .page-title {
    font-size: 1.75rem;
  }

  .box {
    padding: 20px;
  }

  .listbox {
    max-width: 200px;
  }
}

/* Mobile */
@media (max-width: 768px) {
  .page-title {
    font-size: 1.5rem;
  }

  .box {
    padding: 16px;
    border-radius: 16px;
  }

  .flexline {
    flex-direction: column;
    align-items: stretch;
    width: 100%;
  }

  .listbox {
    max-width: 100%;
    width: 100%;
  }

  .filter-title {
    font-size: 1.1rem;
    margin-bottom: 8px;
  }
}

/* Small mobile */
@media (max-width: 576px) {
  .btn-back {
    width: 40px;
    height: 40px;
    min-width: 40px;
    border-radius: 10px;
  }

  .btn-back i {
    font-size: 1rem;
  }

  .page-title {
    font-size: 1.25rem;
  }

  .box {
    padding: 12px;
    border-radius: 12px;
  }
}

/* Orange Button Styles */
.btn-orange {
  background: linear-gradient(135deg, #FF8C42 0%, #FF7A29 100%);
  border: none;
  color: white;
  font-weight: 600;
  padding: 10px 24px;
  border-radius: 8px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(255, 140, 66, 0.3);
}

.btn-orange:hover {
  background: linear-gradient(135deg, #FF7A29 0%, #FF6810 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(255, 140, 66, 0.4);
  color: white;
}

.btn-orange:active {
  transform: translateY(0);
}

.btn-orange:disabled {
  background: #cccccc;
  cursor: not-allowed;
  box-shadow: none;
}

/* Table Responsive Wrapper */
.table-responsive-wrapper {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

/* Action Buttons in Table */
.action-buttons {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}

.btn-orange-action {
  background-color: #FF8C42;
  border: none;
  color: white;
  font-weight: 600;
  padding: 8px 16px;
  border-radius: 6px;
  transition: all 0.3s ease;
  font-size: 0.9rem;
  white-space: nowrap;
}

.btn-orange-action:hover {
  background-color: #FF7A29;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(255, 140, 66, 0.35);
  color: white;
}

.btn-orange-action:active {
  transform: translateY(0);
}

.btn-danger-action {
  background-color: #dc3545;
  border: none;
  color: white;
  font-weight: 600;
  padding: 8px 16px;
  border-radius: 6px;
  transition: all 0.3s ease;
  font-size: 0.9rem;
  white-space: nowrap;
}

.btn-danger-action:hover {
  background-color: #c82333;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(220, 53, 69, 0.35);
  color: white;
}

.btn-danger-action:active {
  transform: translateY(0);
}

/* Cancel Button */
.btn-cancel {
  background-color: white;
  border: 2px solid #FF8C42;
  color: #FF8C42;
  font-weight: 600;
  padding: 10px 24px;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.btn-cancel:hover {
  background-color: #FFF5EF;
  border-color: #FF7A29;
  color: #FF7A29;
}

/* Modern Table Styling */
.modern-table {
  border-radius: 12px;
  overflow: hidden;
}

.modern-table >>> thead {
  background: linear-gradient(135deg, #FF8C42 0%, #FF7A29 100%);
  color: white;
}

.modern-table >>> thead th {
  font-weight: 700;
  text-transform: uppercase;
  font-size: 0.85rem;
  letter-spacing: 0.5px;
  padding: 16px;
  border: none;
}

.modern-table >>> tbody tr {
  transition: all 0.2s ease;
}

.modern-table >>> tbody tr:hover {
  background-color: #FFF5EF;
  transform: scale(1.01);
}

.modern-table >>> tbody td {
  padding: 14px;
  vertical-align: middle;
  font-size: 0.95rem;
}

.error {
  color: #fb725f;
  font-weight: 600;
}

.section-title {
  font-size: 1.4rem;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #FF8C42;
}

#modal-vazio {
    overflow: hidden !important;
}

#modal-vazio .modal-dialog {
    max-height: 92vh;
    margin-top: 7.5vh;
    margin-bottom: 4vh;
}

#modal-vazio .modal-content {
    max-height: inherit;
    overflow-y: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
}

#modal-vazio .modal-content::-webkit-scrollbar {
    width: 0;
    height: 0;
    display: none;
}

body.modal-open {
    overflow: hidden !important;
}
/* Table Responsive */
@media (max-width: 991px) {
  .modern-table >>> thead th {
    padding: 12px 8px;
    font-size: 0.8rem;
  }

  .modern-table >>> tbody td {
    padding: 10px 8px;
    font-size: 0.9rem;
  }
}

@media (max-width: 768px) {
  .table-responsive-wrapper {
    margin: 0 -12px;
    padding: 0 12px;
  }

  .modern-table {
    display: block;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    min-width: 500px;
  }

  .modern-table >>> thead th {
    padding: 10px 6px;
    font-size: 0.75rem;
    white-space: nowrap;
  }

  .modern-table >>> tbody td {
    padding: 8px 6px;
    font-size: 0.85rem;
  }

  .action-buttons {
    flex-direction: column;
    gap: 6px;
  }

  .btn-orange-action {
    width: 100%;
    padding: 6px 12px;
    font-size: 0.8rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
  }

  /* Header responsive on mobile */
  .d-flex.justify-content-between.align-items-center.mb-4 {
    flex-direction: column;
    align-items: flex-start !important;
    gap: 16px;
  }

  .d-flex.justify-content-between.align-items-center.mb-4 .btn-orange {
    width: 100%;
  }
}

@media (max-width: 576px) {
  .modern-table {
    min-width: 400px;
  }

  .modern-table >>> thead th {
    padding: 8px 4px;
    font-size: 0.7rem;
  }

  .modern-table >>> tbody td {
    padding: 6px 4px;
    font-size: 0.8rem;
  }

  .btn-orange {
    padding: 8px 16px;
    font-size: 0.9rem;
    width: 100%;
  }

  .btn-orange-action {
    padding: 6px 10px;
    font-size: 0.75rem;
  }
}

/* Extra small mobile - hide button text, show only icons */
@media (max-width: 400px) {
  .btn-orange-action .btn-text,
  .btn-danger-action .btn-text {
    display: none;
  }

  .btn-orange-action,
  .btn-danger-action {
    padding: 8px 10px;
    min-width: 40px;
  }
}

/* Modal form responsive */
@media (max-width: 768px) {
  .modal .row {
    margin-left: 0;
    margin-right: 0;
  }

  .modal .row > [class*="col-"] {
    padding-left: 0;
    padding-right: 0;
    margin-bottom: 16px;
  }

  .modal .box {
    padding: 16px;
  }

  .modal h1 {
    font-size: 1.5rem;
  }
}
</style>

<style lang="stylus" scoped>
@import '../../../style/colors.styl';
@import '../../../style/mixins.styl';

.btn-show
    float right
    margin-top -15px
    border-radius 32px
    background-color content-theme()
    padding 8px 16px
    color #ffffff
    cursor pointer

.block
    display flex
    text-align left
    align-items left
    flex-direction column
    margin 0
    min-width 20%

.img-holder
    width 50px
    height 50px
    border-radius 8px
    background-color #bbb
</style>

<script>
/* eslint-disable */
import { request } from '@/services'
import EquipamentosModal from '../../modals/EquipamentosModal.vue'
import { DB_ROUTES } from '../../../constants'

export default {
    components: { EquipamentosModal },
    data() {
        return {
            items: [],
            allLocalidades: [],
            loading: true,
            error: null,
            form: {
                // Company fields
                companyNome: '',
                companyEmail: '',
                companyTelefone: '',
                companyDocumento: '',
                companyEstado: null,
                companyCidade: null,
                companyRazaoSocial: '',
                // Manager/Employee fields (modo criação)
                managerNome: '',
                managerEmail: '',
                managerSenha: '',
                managerConfirmarSenha: '',
                managerDocumento: '',
                // Manager/Employee (modo edição - select)
                managerSelecionadoId: null
            },
            empresas: [],
            equipamentos: [],
            empresaSelecionada: {},
            localidadeSelecionada: null,
            localidades: {
                locationState: [],
                locationCity: []
            },
            ordenacao: 'nome',  // Valor inicial para ordenação
            ordenacaoOpcoes: [
                { value: 'name', text: 'Nome' },
                { value: 'created_at', text: 'Data' }
            ],
            fields: [
                { key: 'name', label: 'Nome' },
               // { key: 'created_at', label: 'Data de Criação' },
                { key: 'acoes', label: 'Ações', sortable: false }
            ],
            isEdicao: false,
            empresaEditandoId: null,
            carregandoEdicao: false,
            carregandoGerentes: false,
            gerentesDaEmpresa: []
        }
    },
    computed: {
        isSuperAdmin() {
            return this.$store.getters.isSuperAdmin
        },
        senhasConferem() {
            if (this.isEdicao) return true
            return this.form.managerSenha === this.form.managerConfirmarSenha
        },
        opcoesGerentes() {
            return this.gerentesDaEmpresa.map(g => ({
                value: g.id,
                text: g.name || g.nome || g.email
            }))
        },
        formValido() {
            const dadosEmpresaOk = this.form.companyNome &&
                this.form.companyEmail &&
                this.form.companyTelefone &&
                this.form.companyDocumento &&
                this.form.companyEstado &&
                this.form.companyCidade &&
                this.form.companyRazaoSocial

            if (this.isEdicao) {
                const gerenteOk = this.gerentesDaEmpresa.length === 0
                    ? true
                    : !!this.form.managerSelecionadoId
                return !!(dadosEmpresaOk && gerenteOk)
            }

            return !!(dadosEmpresaOk &&
                this.form.managerNome &&
                this.form.managerEmail &&
                this.form.managerSenha &&
                this.senhasConferem &&
                this.form.managerDocumento)
        },
        estadoOptions() {
            return [
                { value: null, text: 'Selecione o Estado', disabled: true },
                ...this.localidades.locationState
            ]
        },
        cidadeOptions() {
            return [
                { value: null, text: 'Selecione a Cidade', disabled: true },
                ...this.localidades.locationCity
            ]
        }
    },
    mounted() {
        if (!this.$store.getters.isSuperAdmin && !this.$store.getters.isReadOnly) {
            this.$router.push('/')
            return
        }

        this.fetchEmpresas();
    },
    methods: {
        fetchEmpresas() {
            request.get(DB_ROUTES.GET_ALL_COMPANIES, response => {
                this.items = response.data;
                this.empresas = response.data;
                this.loading = false;
            }, error => {
                console.error('Erro ao buscar empresas:', error);
                this.error = 'Erro ao carregar empresas';
                this.loading = false;
            });
        },
        fetchEquipamentos() {
            if (!this.empresaSelecionada || !this.empresaSelecionada.id) {
                console.error('Nenhuma empresa selecionada ou ID ausente');
                return;
            }
            const id = this.empresaSelecionada.id;
            request.get(DB_ROUTES.GET_ALL_EQUIPMENTS,
                (response) => {
                this.equipamentos = response.data.filter(equip => equip.companyId  === id);
                },
                (error) => {
                console.error('Erro ao buscar equipamentos:', error);
                }
            );
        },
        fetchLocalidades () {
    request.get(
        DB_ROUTES.GET_ALL_LOCATIONS, 
        response => {
            if (response.data) {
                // Remove o registro de seed/teste "TP" / "Template"
                this.allLocalidades = response.data.filter(loc => loc.state !== 'TP')

                const states = [...new Set(this.allLocalidades.map(loc => loc.state))]
                    .map(state => ({ value: state, text: state }))
                this.localidades.locationState = states
                this.localidades.locationCity = []
            } else {
                this.error = 'Erro ao carregar localidades'
            }
        },
        error => {
            console.error('Erro ao carregar localidades:', error);
        }
    )
},
        fetchGerentesDaEmpresa(idEmpresa) {
            this.carregandoGerentes = true
            request.get(
                DB_ROUTES.GET_ALL_EMPLOYEES,
                response => {
                    const todos = response.data || []
                    this.gerentesDaEmpresa = todos.filter(func => func.companyId === idEmpresa)
                    this.carregandoGerentes = false
                },
                error => {
                    console.error('Erro ao buscar gerentes da empresa:', error)
                    this.gerentesDaEmpresa = []
                    this.carregandoGerentes = false
                }
            )
        },
        selecionarGerente() {
            const gerente = this.gerentesDaEmpresa.find(g => g.id === this.form.managerSelecionadoId)
            if (gerente) {
                this.form.managerEmail = gerente.email || ''
                this.form.managerDocumento = gerente.document || gerente.documento || ''
                this.form.managerNome = gerente.name || gerente.nome || ''
            }
        },
        abrirModal() {
            if (!this.isSuperAdmin) return
            this.isEdicao = false
            this.empresaEditandoId = null
            this.resetForm()
            if (this.allLocalidades.length === 0) this.fetchLocalidades()
            this.$refs.modalVazio.show();
        },
        abrirModalEdicao(idEmpresa) {
            if (!this.isSuperAdmin) return
            this.isEdicao = true
            this.empresaEditandoId = idEmpresa
            this.carregandoEdicao = true

            if (this.allLocalidades.length === 0) this.fetchLocalidades()
            this.fetchGerentesDaEmpresa(idEmpresa)

            this.$refs.modalVazio.show()

            request.get(
                DB_ROUTES.GET_COMPANY_BY_ID(idEmpresa),
                response => {
                    this.preencherFormularioEdicao(response.data)
                    this.carregandoEdicao = false
                },
                error => {
                    console.error('Erro ao buscar dados da empresa:', error)
                    this.$bvToast.toast('Não foi possível carregar os dados da empresa!', {
                        title: 'Erro',
                        variant: 'danger',
                        solid: true,
                    })
                    this.carregandoEdicao = false
                    this.fecharModal()
                }
            )
        },
        preencherFormularioEdicao(dados) {
            const empresa = dados.company || dados

            this.form.companyNome = empresa.name
            this.form.companyEmail = empresa.email
            this.form.companyTelefone = empresa.phoneNumber
            this.form.companyDocumento = empresa.document
            this.form.companyRazaoSocial = empresa.legalName

            const setLocalidade = () => {
                const localidade = this.allLocalidades.find(loc => loc.id === empresa.locationId)
                if (localidade) {
                    this.form.companyEstado = localidade.state
                    this.updateCitiesByState()
                    this.form.companyCidade = empresa.locationId
                }
            }

            if (this.allLocalidades.length === 0) {
                const interval = setInterval(() => {
                    if (this.allLocalidades.length > 0) {
                        clearInterval(interval)
                        setLocalidade()
                    }
                }, 200)
            } else {
                setLocalidade()
            }

            this.form.managerSelecionadoId = null
            this.form.managerEmail = ''
            this.form.managerNome = ''
            this.form.managerDocumento = ''
            this.form.managerSenha = ''
            this.form.managerConfirmarSenha = ''
        },
        resetForm() {
            this.form = {
                companyNome: '',
                companyEmail: '',
                companyTelefone: '',
                companyDocumento: '',
                companyEstado: null,
                companyCidade: null,
                companyRazaoSocial: '',
                managerNome: '',
                managerEmail: '',
                managerSenha: '',
                managerConfirmarSenha: '',
                managerDocumento: '',
                managerSelecionadoId: null
            }
            this.gerentesDaEmpresa = []
        },
        fecharModal() {
            this.$refs.modalVazio.hide()
            this.isEdicao = false
            this.empresaEditandoId = null
            this.carregandoEdicao = false
        },
        async confirmarExclusao(empresa) {
            if (!this.isSuperAdmin) return
            const confirmado = await this.$bvModal.msgBoxConfirm(
                `Tem certeza que deseja excluir a empresa "${empresa.name}"? Essa ação não pode ser desfeita.`,
                {
                    title: 'Confirmar exclusão',
                    okVariant: 'danger',
                    okTitle: 'Excluir',
                    cancelTitle: 'Cancelar',
                    centered: true
                }
            )

            if (confirmado) {
                this.excluirEmpresa(empresa.id)
            }
        },
        excluirEmpresa(idEmpresa) {
            if (!this.isSuperAdmin) return
            request.delete(
                DB_ROUTES.DELETE_COMPANY(idEmpresa),
                _ => {
                    this.$bvToast.toast('Empresa excluída com sucesso!', {
                        title: 'Sucesso',
                        variant: 'success',
                        solid: true,
                    })
                    this.fetchEmpresas()
                },
                error => {
                    this.$bvToast.toast('Não foi possível excluir a empresa!', {
                        title: 'Erro',
                        variant: 'danger',
                        solid: true,
                    })
                    console.error('Erro ao excluir empresa:', error)
                    this.error = 'Erro ao excluir empresa'
                }
            )
        },
        abrirEquipamentosModal(idEmpresa) {
        const empresa = this.empresas.find(e => e.id === idEmpresa);
        if (empresa) {
            this.empresaSelecionada = empresa;
            this.fetchEquipamentos();
            this.$refs.equipamentosModal.show();
        } else {
            console.error('Empresa não encontrada com o id:', idEmpresa);
        }
        },
        updateCitiesByState () {
            const selectedState = this.form.companyEstado
            if (selectedState) {
                const cities = this.allLocalidades
                    .filter(loc => loc.state === selectedState)
                    .map(loc => ({
                        value: loc.id,
                        text: loc.city
                    }))
                this.localidades.locationCity = cities
            } else {
                this.localidades.locationCity = []
            }
            this.form.companyCidade = null
        },
        irParaAnalises(empresaId) {
            this.$router.push({ path: '/analises', query: { empresa_id: empresaId } }); //Ainda nao tem
        },
        formatarTelefone(value) {
            let telefone = value.replace(/\D/g, '')
            if (telefone.length > 10) {
                telefone = telefone.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3')
            } else {
                telefone = telefone.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3')
            }
            this.form.companyTelefone = telefone
        },
        formatarCompanyDocumento(value) {
            let documento = value.replace(/\D/g, '')
            if (documento.length === 11) {
                documento = documento.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4') // CPF
            } else if (documento.length === 14) {
                documento = documento.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5') // CNPJ
            }
            this.form.companyDocumento = documento
        },
        formatarManagerDocumento(value) {
            let documento = value.replace(/\D/g, '')
            if (documento.length === 11) {
                documento = documento.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4') // CPF
            } else if (documento.length === 14) {
                documento = documento.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5') // CNPJ
            }
            this.form.managerDocumento = documento
        },
        formatDate(date) {
            const formattedDate = new Date(date);
            return formattedDate.toLocaleDateString('pt-BR');
        },
        ordenarEmpresas() {
            if (this.ordenacao === 'name') {
                this.items = this.empresas.sort((a, b) => a.key.localeCompare(b.key));
            } else if (this.ordenacao === 'created_at') {
                this.items = this.empresas.sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
            }
        },
        onSubmit() {
            if (!this.isSuperAdmin) return
            if (!this.formValido) return

            if (this.isEdicao) {
                const payload = {
                    id: this.empresaEditandoId,
                    name: this.form.companyNome,
                    email: this.form.companyEmail,
                    phoneNumber: this.form.companyTelefone,
                    document: this.form.companyDocumento,
                    locationId: this.form.companyCidade,
                    legalName: this.form.companyRazaoSocial,
                    employeeId: this.form.managerSelecionadoId || null
                };

                request.put(
                    DB_ROUTES.PUT_COMPANY(this.empresaEditandoId),
                    payload,
                    _ => {
                        this.$bvToast.toast('Empresa atualizada com sucesso!', {
                            title: 'Sucesso',
                            variant: 'success',
                            solid: true,
                        });
                        this.fecharModal();
                        this.fetchEmpresas();
                        this.resetForm();
                    },
                    error => {
                        this.$bvToast.toast('Não foi possível atualizar a empresa!', {
                            title: 'Erro',
                            variant: 'danger',
                            solid: true,
                        });
                        console.error('Erro ao atualizar empresa:', error);
                        this.error = 'Erro ao atualizar empresa';
                    }
                );
            } else {
                const payload = {
                    company: {
                        name: this.form.companyNome,
                        email: this.form.companyEmail,
                        phoneNumber: this.form.companyTelefone,
                        document: this.form.companyDocumento,
                        locationId: this.form.companyCidade,
                        legalName: this.form.companyRazaoSocial
                    },
                    employee: {
                        name: this.form.managerNome,
                        email: this.form.managerEmail,
                        password: this.form.managerSenha,
                        document: this.form.managerDocumento
                    }
                };

                request.post(
                    DB_ROUTES.POST_COMPANY,
                    payload,
                    _ => {
                        this.$bvToast.toast('Nova empresa cadastrada!', {
                            title: 'Sucesso',
                            variant: 'success',
                            solid: true,
                        });
                        this.fecharModal();
                        this.fetchEmpresas();
                        this.resetForm();
                    },
                    error => {
                        this.$bvToast.toast('O email já existe no sistema. Não foi possível cadastrar a empresa!', {
                            title: 'Erro',
                            variant: 'danger',
                            solid: true,
                        });
                        console.error('Erro ao criar empresa:', error);
                        this.error = 'Erro ao criar empresa';
                    }
                );
            }
        }
    }
}
</script>